export default __webpack_public_path__ + "static/media/story-3r.ecc8f68c.png";